var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-card',{staticClass:"mb-4"},[_c('create',{on:{"neeFetch":_vm.fetchAdditionalProducts}})],1),_c('additionalProductsTable',{attrs:{"data":_vm.additionalProducts},on:{"neeFetch":_vm.fetchAdditionalProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }